import React, { useState, useEffect } from 'react';
import './TestimonialsPage.css';

const TestimonialsPage = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Registered Nurse',
      facility: 'City General Hospital',
      content: 'Solace Staffing helped me find my dream position in the ICU. The team was professional, supportive, and really understood what I was looking for in my career. They made the entire process seamless and stress-free.',
      rating: 5,
      image: '👩‍⚕️',
      location: 'Chicago, IL'
    },
    {
      id: 2,
      name: 'Dr. Michael Chen',
      role: 'Emergency Medicine Physician',
      facility: 'Metro Medical Center',
      content: 'Working with Solace Staffing was seamless. They matched me with a facility that perfectly aligned with my career goals and values. The support throughout the process was exceptional, and I couldn\'t be happier with my new position.',
      rating: 5,
      image: '👨‍⚕️',
      location: 'Phoenix, AZ'
    },
    {
      id: 3,
      name: 'Lisa Rodriguez',
      role: 'Nurse Manager',
      facility: 'Regional Healthcare System',
      content: 'We\'ve been partnering with Solace Staffing for over two years. They consistently provide us with qualified, reliable healthcare professionals who integrate seamlessly into our team. Their attention to detail and commitment to quality is unmatched.',
      rating: 5,
      image: '👩‍💼',
      location: 'Denver, CO'
    },
    {
      id: 4,
      name: 'James Thompson',
      role: 'Physical Therapist',
      facility: 'Rehabilitation Center',
      content: 'The team at Solace Staffing made my job search stress-free. They found me a position that offers great work-life balance and competitive benefits. I highly recommend them to any healthcare professional looking for their next opportunity.',
      rating: 5,
      image: '👨‍⚕️',
      location: 'Austin, TX'
    },
    {
      id: 5,
      name: 'Dr. Emily Davis',
      role: 'Chief Medical Officer',
      facility: 'University Hospital',
      content: 'Solace Staffing understands healthcare. They\'ve helped us fill critical positions quickly with top-tier professionals who fit our culture perfectly. Their expertise in healthcare staffing is evident in every interaction.',
      rating: 5,
      image: '👩‍⚕️',
      location: 'Seattle, WA'
    },
    {
      id: 6,
      name: 'Maria Garcia',
      role: 'Surgical Technologist',
      facility: 'Surgical Center',
      content: 'I was impressed by how quickly Solace Staffing found me a position that matched my skills and preferences. The communication was excellent throughout the process, and I felt supported every step of the way.',
      rating: 5,
      image: '👩‍⚕️',
      location: 'Miami, FL'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < rating ? 'filled' : ''}`}>
        ⭐
      </span>
    ));
  };

  return (
    <div className="testimonials-page">
      <div className="page-header">
        <div className="container">
          <h1>Client Testimonials</h1>
          <p>Hear from healthcare professionals and facilities who have experienced the Solace Staffing difference</p>
        </div>
      </div>

      <div className="container">
        <div className="testimonials-intro">
          <h2>Why Our Clients Trust Us</h2>
          <p>
            Our success is measured by the success of our clients. We're proud to share these testimonials 
            from healthcare professionals and facilities who have experienced exceptional results working with Solace Staffing.
          </p>
        </div>

        <div className="testimonials-container">
          <div className="testimonial-card">
            <div className="testimonial-content">
              <div className="testimonial-image">
                <span className="avatar">{testimonials[currentTestimonial].image}</span>
              </div>
              
              <div className="testimonial-text">
                <div className="stars">
                  {renderStars(testimonials[currentTestimonial].rating)}
                </div>
                
                <blockquote>
                  "{testimonials[currentTestimonial].content}"
                </blockquote>
                
                <div className="testimonial-author">
                  <h4>{testimonials[currentTestimonial].name}</h4>
                  <p className="author-role">{testimonials[currentTestimonial].role}</p>
                  <p className="author-facility">{testimonials[currentTestimonial].facility}</p>
                  <p className="author-location">{testimonials[currentTestimonial].location}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="testimonial-navigation">
            <button 
              className="nav-btn prev" 
              onClick={prevTestimonial}
              aria-label="Previous testimonial"
            >
              ‹
            </button>
            
            <div className="testimonial-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                  onClick={() => goToTestimonial(index)}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
            
            <button 
              className="nav-btn next" 
              onClick={nextTestimonial}
              aria-label="Next testimonial"
            >
              ›
            </button>
          </div>
        </div>

        <div className="testimonials-stats">
          <div className="stat">
            <div className="stat-number">98%</div>
            <div className="stat-label">Client Satisfaction</div>
          </div>
          <div className="stat">
            <div className="stat-number">500+</div>
            <div className="stat-label">Successful Placements</div>
          </div>
          <div className="stat">
            <div className="stat-number">50+</div>
            <div className="stat-label">Partner Facilities</div>
          </div>
          <div className="stat">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Support Available</div>
          </div>
        </div>

        <div className="cta-section">
          <h2>Ready to Join Our Success Stories?</h2>
          <p>Let us help you find your next healthcare opportunity or the perfect professional for your facility.</p>
          <div className="cta-buttons">
            <a href="/contact" className="btn btn-primary">Contact Us</a>
            <a href="/jobs" className="btn btn-secondary">View Jobs</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsPage;
